import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IOrderState } from "./types";
import { IOrder } from "../../../services/origin/orderApi/types";

export const orderInitialState: IOrderState = {
  order: undefined,
};

const orderSlice = createSlice({
  name: "order",
  initialState: orderInitialState,
  reducers: {
    selectOrderItem: (state, action: PayloadAction<IOrder | undefined>) => {
      state.order = action.payload;
    },
    clearOrderItem: (state) => {
      state.order = undefined;
    },
  },
});

export const { selectOrderItem, clearOrderItem } = orderSlice.actions;
export default orderSlice.reducer;
